import { Card, CardMedia } from "@mui/material";

const LocationBanner = () => {
  return (
    <div className="w-full flex flex-col md:flex-row h-full bg-[#1D1D1D]">
      <div className="flex flex-col md:w-[70%] h-full py-14">
        <Card
          sx={{
            borderRadius: "15px",
            width: "90%",

            minHeight: "400px",
            height: "100%",
            marginX: "auto",
          }}
        >
          <CardMedia sx={{ height: "100%" }}>
            {" "}
            {/* Make sure CardMedia takes the full height of its parent */}
            <iframe
              title="Factory Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d64253493.4371591!2d76.171058!3d10.600894!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7ebc7a36195bb%3A0x7a7cccad09b292b!2sV%20PACK!5e0!3m2!1sen!2sin!4v1708450353927!5m2!1sen!2sin"
              width="100%"
              height="400vh"
              style={{ border: 0 }}
              loading="lazy"
            ></iframe>
          </CardMedia>
        </Card>
      </div>

      <div className="flex flex-col justify-evenly text-center md:text-left text-white font-HNlight">
        <div className="flex flex-col justify-end h-1/2">
          <div>Our Location</div>
          <div className="pb-10 text-4xl font-HNmed px-10 md:px-0">
            Connecting Near and Far
          </div>
        </div>
        <div className="flex flex-col content-start h-1/2">
          <div>Headquaters</div>
          <div className="text-[#ffffff9b] px-20 py-10  md:pr-[60%] md:p-0">
            Welcome to Vpack! Located at the heart of innovation, our
            headquarters is where cutting-edge technology meets unparalleled
            craftsmanship.
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationBanner;
